import type {PrismicDocument} from '@prismicio/types';
import {useABTest} from '@malt/feature-flags';

export function useABTestSlices(prismicDocument: PrismicDocument) {
    const {getVariation} = useABTest();

    const slices = (prismicDocument?.data.slices || []).filter((slice: any) => {
        const {abTest} = slice.primary;
        if (abTest) {
            const [campaign, variation] = abTest.split('.');
            if (campaign && variation) {
                return getVariation(campaign) === variation;
            }
            return true;
        }
        return true;
    });

    return {slices};
}
